var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan-class"},[_c('div',[_c('div',{staticClass:"top-box"},[_c('span',[_vm._v("某某课时教案")]),_c('i',{staticClass:"el-icon-close",staticStyle:{"font-size":"30px","cursor":"pointer"},on:{"click":_vm.closePlanClick}})]),_c('div',{staticClass:"content-box",domProps:{"innerHTML":_vm._s(_vm.plan)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }